import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from "rxjs/Subscription";
import { NotificationsService } from "angular2-notifications";

import { GUID, Param } from "app/brightserve/brightserve.module";
import { IncidentDetail, SlimScrollOptions } from "app/shared/shared.module";
import { AddonService } from "app/add-ons/addon.service";

@Component({
    selector: 'app-addon-incident-details',
    templateUrl: './addon-incident-details.component.html',
    styleUrls: ['./addon-incident-details.component.css']
})
export class AddonIncidentDetailsComponent implements OnInit {

    IncidentDetails: IncidentDetail[];
    IncidentAdd: boolean = false;
    IncidentTraumaText: string;

    GetIncidentTraumaSubscription: Subscription;
    AddIncidentTraumaSubscription: Subscription;

    SlimScrollOptions = SlimScrollOptions;

    @Input() IncidentId: GUID;
    @Input() EnableAdd: boolean = false;

    constructor(private addonService: AddonService, private _notification: NotificationsService) { }

    ngOnInit() {
        this.Reset();
    }

    ngOnChanges() {
        this.GetIncidentTraumaDetails();
    }

    ngOnDestroy() {
        if (this.GetIncidentTraumaSubscription != null)
            this.GetIncidentTraumaSubscription.unsubscribe();
        if (this.AddIncidentTraumaSubscription != null)
            this.AddIncidentTraumaSubscription.unsubscribe();
    }

    OpenAdd() {
        this.IncidentAdd = true;
    }

    GetIncidentTraumaDetails() {
        if (this.IncidentId) {
            this.GetIncidentTraumaSubscription = this.addonService.GetIncidentTraumaDetails(this.IncidentId).subscribe(
                details => {
                    this.IncidentDetails = details;
                }, err => {
                    this._notification.error("Data Error", "Incident/Trauma details data for this incident could not be obtained.");
                }
            );
        }
    };

    AddIncidentTraumaDetails() {
        var detail = IncidentDetail.BlankIncidentDetail();
        detail.Text = this.IncidentTraumaText;
        detail.Status = new Param({ Entity: "Annotation", Field: "Status", Value: "New" });
        this.AddIncidentTraumaSubscription = this.addonService.AddIncidentTraumaToIncident(this.IncidentId, detail).subscribe(
            details => {
                this.Reset();
                this.GetIncidentTraumaDetails();
                this._notification.success("Detail Saved", "Incident/Trauma detail was added to this incident successfully.");
            }, err => {
                this._notification.error("Detail Not Saved", "Incident/Trauma detail was not added to this incident successfully.");
            }
        );
    }

    Reset() {
        this.IncidentAdd = false;
        this.IncidentTraumaText = "";
    }
}



// WEBPACK FOOTER //
// ./src/app/add-ons/incident-details/addon-incident-details.component.ts